import React from 'react';
import ErrorLabel from '../Label/ErrorLabel';

type Props = {
	label: string;
	description: string;
	required?: boolean;
	error?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export default function InputDescription({
	label,
	description,
	required,
	error,
	...inputProps
}: Props): JSX.Element {
	return (
		<div className="d-flex inline-input-container">
			<div>
				<div className="mb-10">
					<label className={`form-label ${required ? 'label-required' : ''}`}>
						{label}
					</label>
					<input
						type="text"
						className="form-control form-control-solid"
						placeholder="Ejemplo de texto"
						{...inputProps}
					/>
					{error ? <ErrorLabel text={error} /> : null}
				</div>
			</div>
			<div className="d-flex align-items-center">
				<p>{description}</p>
			</div>
		</div>
	);
}
